import { render, staticRenderFns } from "./projectTypes.vue?vue&type=template&id=e8b5d9ba&scoped=true&"
import script from "./projectTypes.vue?vue&type=script&lang=js&"
export * from "./projectTypes.vue?vue&type=script&lang=js&"
import style0 from "./projectTypes.vue?vue&type=style&index=0&id=e8b5d9ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b5d9ba",
  null
  
)

export default component.exports